import { QueryVariablesBuilder } from 'src/common/helpers/GQLRequestsHelper/QueryVariablesBuilder';

import { MfaIssueDetailsQueryVariables } from '../MfaIssueDetails.generated';

const ISSUE_ID_PARAM_NAME = 'issueId';
const RUN_ID_PARAM_NAME = 'runId';

export const buildMfaIssueDetailsVariables = (
	issueId: string,
	runId: string
): MfaIssueDetailsQueryVariables => {
	const variablesBuilder = new QueryVariablesBuilder<MfaIssueDetailsQueryVariables>();

	return variablesBuilder
		.addConditionParam(ISSUE_ID_PARAM_NAME, issueId)
		.addConditionParam(RUN_ID_PARAM_NAME, runId)
		.getVariables();
};
